import {
  APP_CODE,
  HttpService,
  SchedulesProvider,
  SchedulesService,
} from "@sportal/api";

export const makeScheduleService = (http: HttpService, url: string) =>
  new SchedulesService(new SchedulesProvider(http, url, APP_CODE.SB));
